export const Logo = ({ compact = false, light = false }) => (
  <div className="flex items-center gap-3" data-testid="ruby-mill-logo">
    <img
      src="/rm-emblem.png"
      alt="Ruby Mill emblem"
      className="h-10 w-10 rounded-full object-cover"
    />
    {!compact && (
      <span
        className={`font-heading text-[11px] font-medium uppercase tracking-[0.42em] ${
          light ? "text-[#1C1512]" : "text-slate-200"
        }`}
      >
        Ruby Mill
      </span>
    )}
  </div>
);
